var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTdark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 5,
    fill: "#303C46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91913 17V13.96C8.91913 13.288 9.06846 12.8027 9.36713 12.504C9.66579 12.1947 10.0445 11.9813 10.5031 11.864L10.5191 11.816L8.75912 11.144V10.616C8.75912 10.1787 8.90313 9.768 9.19113 9.384C9.47913 8.98933 9.88979 8.67467 10.4231 8.44C10.9671 8.19467 11.6125 8.072 12.3591 8.072C13.0098 8.072 13.6125 8.17867 14.1671 8.392C14.7218 8.59467 15.1645 8.92 15.4951 9.368C15.8365 9.80533 16.0071 10.3813 16.0071 11.096V17H14.5831V11.24C14.5831 10.5253 14.3645 10.0187 13.9271 9.72C13.5005 9.41067 12.9725 9.256 12.3431 9.256C11.6925 9.256 11.1751 9.39467 10.7911 9.672C10.4071 9.93867 10.2151 10.28 10.2151 10.696L11.9431 11.56L11.8151 12.328C11.4205 12.328 11.0738 12.4613 10.7751 12.728C10.4871 12.984 10.3431 13.3947 10.3431 13.96V17H8.91913Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdark);
export default __webpack_public_path__ + "static/media/tdark.e7bdb6f3734b3e9affd46ff72fa8be90.svg";
export { ForwardRef as ReactComponent };